module.exports = __webpack_public_path__ + "teqbahn-assets/media/13.4ab82240.jpg";